function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.792 15.583h-3.37a8.607 8.607 0 00-.482-1.833h3.388c.003-.066.005-.142.005-.23 0-3.39-.802-4.353-3.666-4.353-.745 0-1.35.065-1.839.221a4.57 4.57 0 00-1.37-3.494 3.208 3.208 0 115.875 1.85c2.08.788 2.834 2.714 2.834 5.777 0 1.375-.459 2.062-1.375 2.062zm-2.75-9.625a1.375 1.375 0 11-2.75 0 1.375 1.375 0 012.75 0zM3.437 20.167c-1.069 0-1.604-.764-1.604-2.292 0-3.493.926-5.655 3.5-6.486a3.667 3.667 0 115.833 0c2.575.831 3.5 2.993 3.5 6.486 0 1.528-.534 2.292-1.604 2.292H3.438zm6.646-11a1.833 1.833 0 11-3.666 0 1.833 1.833 0 013.666 0zm2.75 8.708c0 .196-.01.349-.025.458H3.692a3.738 3.738 0 01-.025-.458c0-3.856 1.036-5.042 4.583-5.042s4.583 1.186 4.583 5.042z"
});

var SvgParticipants = function SvgParticipants(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22"
  }), _ref);
};

export default SvgParticipants;